import { useEffect, useRef } from "react";

// Empêche l'écran de se verrouiller (ex: pendant la cuisine).
export function useWakeLock(active = true) {
  const ref = useRef(null);

  useEffect(() => {
    if (!active || !("wakeLock" in navigator)) return;
    let released = false;

    const request = async () => {
      try {
        ref.current = await navigator.wakeLock.request("screen");
      } catch (e) {
        /* ignoré (batterie faible, onglet caché, non supporté) */
      }
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible" && !released) request();
    };

    request();
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      released = true;
      document.removeEventListener("visibilitychange", onVisibility);
      if (ref.current) {
        ref.current.release().catch(() => {});
        ref.current = null;
      }
    };
  }, [active]);
}
